export default "__VITE_PUBLIC_ASSET__6db240e6__"